import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { getImageUrl } from '../../../util'

import { ImageIconWrapper } from './style'

const ImageIcon = ({ className, row, size = '' }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const handleLoad = () => {
    setIsLoaded(true)
  }
  const getText = () => {
    if (row?.BrandName) {
      const txtArr = row.BrandName.split(' ')
      if (txtArr.length > 1) {
        return `${txtArr[0].charAt(0)}${txtArr[1].charAt(0)}`
      }
      return row.BrandName.slice(0, 2)
    }
    return ''
  }
  const logoPath = getImageUrl('logos/projects', row?.ProjectId, 'png')

  return (
    <ImageIconWrapper
      className={`${className} ${size} image${isLoaded ? 'Loaded' : 'NotLoaded'}`}
      data-projectId={row?.ProjectId}
    >
      <img onLoad={handleLoad} src={logoPath} alt='' />
      <span>{getText()}</span>
    </ImageIconWrapper>
  )
}

ImageIcon.propTypes = {
  className: PropTypes.string,
  row: PropTypes.object,
  size: PropTypes.string,
}

export default ImageIcon
